//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Btn from '../components/Btn.vue';
import PageOverlay from '../components/PageOverlay.vue';

export default {
	name: 'CityHandler',
	components: { Btn: Btn, PageOverlay: PageOverlay },
	props: {
		curentCity: {
			type: String,
			default: function _default() {
				return '';
			}
		}
	},
	data: function data() {
		return {
			overlayIsShow: false

		};
	},

	computed: {
		domains: function domains() {
			return this.$store.state.settings.domains || {};
		},
		currentDomain: function currentDomain() {
			if (process.browser) {
				var host = location.host;
			}
			var domains = this.domains;
			var cd = this.curentCity;
			for (var i in domains) {
				if (domains[i].host == host) {
					cd = domains[i].name;
				}
			}
			return cd;
		}
	},
	methods: {
		showModalChoise: function showModalChoise() {
			this.overlayIsShow = true;
		},
		closeModalChoise: function closeModalChoise() {
			this.overlayIsShow = false;
		},
		goToHost: function goToHost(host) {
			if (process.browser) {
				location.host = host;
			}
		}
	}

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/CityHandler.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/CityHandler.vue
// module chunks = 5